export default "__VITE_ASSET__BCBxRxb1__"